import { Route } from "react-router-dom";
import ProviderUserList from "../components/index";
import ProviderMiddleware from "../../provider-middleware/components";

const ProviderUserListiRoutes = () => (
  <>
    <Route path="user-list" element={<ProviderMiddleware><ProviderUserList /></ProviderMiddleware>} />
  </>
);


export default ProviderUserListiRoutes;